// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MaterialRowTooltip_wrapper__NEIwk","wrapper_column":"MaterialRowTooltip_wrapper_column__8Hpu_","exclamationMark":"MaterialRowTooltip_exclamationMark__5kaBW"};